import Component from "../abstracts/Component";
import { isMobile, MobileBreakpoint } from "../utils/MobileUtils";

export default class CollapseComponent extends Component {
  get COMPONENTNAME() {
    return "CollapseComponent";
  }

  get SELECTORS() {
    return {
      collapse: "[data-collapse]",
      trigger: "[data-trigger]",
      tab: "[data-tab]",
      collapseBoxes: "[data-collapse-box]",
      collapseContent: "[data-collapse-content]",
      collapseTrigger: "[data-collapse-trigger]"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.maxRes = this.$component.dataset.collapseMaxres;
    this.collapses = this.$component.querySelectorAll(this.SELECTORS.collapse);
    // globals
    this.collapseBoxes = this.$component.querySelectorAll(
      this.SELECTORS.collapseBoxes
    );
    setTimeout(function() {
      let collapsedElements = $(".s-p__country-content");
      if (collapsedElements.length > 0) {
        collapsedElements.map((i, elem) => {
          $(elem)
            .children("[data-collapse-content]")
            .css({ transition: " max-height .3s ease-out" });
        });
      }
    }, 500);

    this.collapseTrigger = this.$component.querySelectorAll(
      this.SELECTORS.collapseTrigger
    );
  }

  listenTrigger() {
    this.collapses.forEach((collapse, i) => {
      let trigger = collapse.querySelector(this.SELECTORS.trigger);
      if (
        trigger != null &&
        trigger.getAttribute("data-trigger") !== "triggered"
      ) {
        trigger.addEventListener("click", () =>
          this.handleTrigger(collapse, i)
        );
        trigger.setAttribute("data-trigger", "triggered");
        if (
          trigger.getAttribute("data-collapse-opened") != null &&
          trigger.getAttribute("data-collapse-opened") === "true"
        ) {
          // trigger the open
          trigger.click();
        }
      }
    });
  }

  handleTrigger(collapse, i) {
    this.collapses.forEach((item, index) => {
      if (index === i) {
        item.classList.toggle("collapsed");
        this.$emit(this.$customEvents.COLLAPSE_EVENTS.toggle);
      } else {
        item.classList.add("collapsed");
      }
    });
  }

  setCollapse() {
    this.collapses.forEach(collapse => {
      if (!collapse.classList.contains("collapsed")) {
        let tabs = collapse.querySelectorAll(this.SELECTORS.tab);
        tabs.forEach(tab => {
          let height = tab.offsetHeight;
          tab.style.maxHeight = `${height}px`;
        });
        if (collapse.getAttribute("data-collapse-triggered") == null) {
          collapse.classList.add("collapsed");
        }
      }
    });
  }

  initCollapseMobile() {
    if (this.maxRes) {
      if (this.maxRes === "lg" && isMobile(MobileBreakpoint.Max1023)) {
        this.setCollapse();
        this.listenTrigger();
      } else if (this.maxRes === "md" && isMobile(MobileBreakpoint.Max767)) {
        this.setCollapse();
        this.listenTrigger();
      }
    } else {
      this.setCollapse();
      this.listenTrigger();
    }
  }

  initCollapse(
    collapseBoxes = this.collapseBoxes,
    collapseTrigger = this.collapseTrigger
  ) {
    if (collapseBoxes) {
      collapseBoxes.forEach(tab => {
        const answerBox = tab.querySelector(this.SELECTORS.collapseContent);
        answerBox.style.maxHeight = this.getHiddenHeight(answerBox) + "px";
      });
    }

    // add collapsed on collapsable boxes
    if (collapseBoxes != null) {
      collapseBoxes.forEach(collapse => {
        if (collapse.getAttribute("data-collapse-triggered") == null) {
          let contents = collapse.querySelectorAll(
            this.SELECTORS.collapseContent
          );
          let noCollapse = false;
          contents.forEach(content => {
            noCollapse =
              content.dataset.noCollapse === "true" ? true : noCollapse;
            let height = content.offsetHeight;
            if (collapse.hasAttribute("data-collapse-more-height")) {
              let moreHeight = height * 1.2;
              content.style.maxHeight = moreHeight + "px";
            } else if ($("#collapse-voucher", collapse) !== null) {
              return;
            } else {
              content.style.maxHeight = `${height}px`;
            }
          });
          !noCollapse && collapse.classList.add("collapsed");
          collapse.setAttribute("data-collapse-triggered", "");
        }
      });
    }
    // bind click
    if (collapseTrigger != null) {
      collapseTrigger.forEach((trigger, i) => {
        if (trigger.getAttribute("data-collapse-triggered") == null) {
          trigger.addEventListener("click", () => {
            this.handleCollapseTrigger(trigger);
          });
          trigger.setAttribute("data-collapse-triggered", "");
          if (
            trigger.getAttribute("data-collapse-opened") != null &&
            trigger.getAttribute("data-collapse-opened") === "true"
          ) {
            // trigger the open
            trigger.click();
          }
        }
      });
    }
  }

  getHiddenHeight(el) {
    if (!el?.cloneNode) {
      return null;
    }

    const clone = el.cloneNode(true);
    // find all the input[type=radio] elements in the clone and uncheck each of themAdd commentMore actions
    const radioButtons = clone.querySelectorAll("input[type=radio]");
    radioButtons.forEach(input => {
      input.checked = false; // prevent each radio button in the clone from being selected
    });
    const parentWidth = el.parentNode.offsetWidth;
    Object.assign(clone.style, {
      overflow: "visible",
      height: "auto",
      width: parentWidth + "px",
      position: "absolute",
      opacity: "0",
      visibility: "hidden",
      display: "block"
    });
    // temporarily add the clone to the DOM
    el.after(clone);
    // calculate the height
    const height = clone.offsetHeight;
    // remove the clone
    clone.remove();

    return height;
  }

  handleCollapseTrigger(trigger) {
    let target = document.querySelector(
      '[data-collapse-box="' +
        trigger.getAttribute("data-collapse-trigger") +
        '"]'
    );
    if (target != null) {
      target.classList.toggle("collapsed");
      target.classList.toggle("opened");
      trigger.classList.toggle("opened");
      trigger.setAttribute(
        "aria-expanded",
        target.classList.contains("opened")
      );
      if (trigger.dataset.collapseBodyclass != null) {
        document.body.classList.toggle(trigger.dataset.collapseBodyclass);
      }
      if (this.$component.hasAttribute("data-collapse-others")) {
        this.collapseOthers(trigger.getAttribute("data-collapse-trigger"));
      }
    }
  }

  collapseOthers(id) {
    this.collapseBoxes.forEach(box => {
      if (box.dataset.collapseBox !== id && box.classList.contains("opened")) {
        let trigger = this.$component.querySelector(
          '[data-collapse-trigger="' + box.dataset.collapseBox + '"]'
        );
        trigger.classList.toggle("opened");
        box.classList.toggle("collapsed");
        box.classList.toggle("opened");
      }
    });
  }

  isTablet() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }

  isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  refreshHeight(event, payload) {
    if (!payload) return;
    const sourceEl = payload.extraDiv;
    if (!sourceEl) return;
    const collapseContentEl = sourceEl.closest(this.SELECTORS.collapseContent);
    if (!collapseContentEl) return;
    const firstChild = collapseContentEl.children[0];
    if (!firstChild || firstChild.offsetHeight === 0) return;
    // Defer style update to after layout recalculations
    requestAnimationFrame(() => {
      collapseContentEl.style.maxHeight = firstChild.offsetHeight + "px";
    });
  }

  bindEvents() {
    let ctx = this;
    // update the collapsed content
    this.$on(
      this.$customEvents.COLLAPSE_EVENTS.update,
      ({ event, payload }) => {
        this.refreshHeight(event, payload);
      }
    );
  }

  render() {
    super.render();
    this.log("Rendering...");
    // check mobile
    if (this.maxRes !== null && typeof this.maxRes !== "undefined") {
      if (this.maxRes == "lg" && this.isTablet()) {
        this.initCollapse();
      } else if (this.maxRes == "md" && this.isMobile()) {
        this.initCollapse();
      }
    } else {
      this.initCollapse();
    }
    // for mobile tabs
    this.initCollapseMobile();
    this.bindEvents();
  }
}
